import BlockNews from './BlockNews'

export default BlockNews
